"use client";
import styled from "styled-components";

export const SelectWrapper = styled.div`
  display: flex;
  margin-bottom: 32px;
  @media (min-width: 1024px) {
    margin-bottom: 64px;
  }
`;

export const SelectInner = styled.div`
  display: flex;
  overflow: auto;
  margin: 0 -24px;
  padding: 0 24px;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Title = styled.h1`
  font-size: 32px;
  line-height: 40px;
  font-variation-settings: "wght" 700;
  margin: 0;
  margin-bottom: 32px;
  @media (min-width: 1024px) {
    font-size: 64px;
    line-height: 72px;
    margin-bottom: 50px;
  }
`;

export const Row = styled.div`
  margin-bottom: 32px;
  gap: 32px;
  display: grid;
  grid-template-columns: 100%;
  @media (min-width: 1024px) {
    display: flex;
    > * {
      flex: 1;
      width: 0;
    }
  }
`;
